import { read } from "./read"

export const landingPage = {
  read,
}
